import type { MetaFunction } from "react-router";
import ForProfessionals from "@/pages/ForProfessionals";

export const meta: MetaFunction = () => {
  return [
    { title: "AI-Assisted Copywriting for Professionals, Freelancers & Ghostwriters | Arcitext" },
    {
      name: "description",
      content: "Write better and faster with Arcitext. A context aware AI writing app, that locks in your writing style, and gives you personalized feedback.",
    },
    {
      name: "keywords",
      content: "AI writing for professionals, content creator tools, personal blogging assistant, authentic writing style AI, writing consistency tool",
    },
    {
      tagName: "link",
      rel: "canonical",
      href: "https://www.arcitext.com/for-professionals",
    },
  ];
};

// This route uses static pre-rendering
export default function ForProfessionalsRoute() {
  return <ForProfessionals />;
}
